import React,{useEffect,useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import clinicService from '../../services/clinic.service'
import Feedback from './Feedback'
import FeedbackSat from './FeedbackSat'
import FeedbackUnsat from './FeedbackUnsat'
import { useSearchParams } from 'react-router-dom'
import {Helmet} from 'react-helmet';

import NavTab from './NavTab'
import PageLoading from '../common/PageLoading'

const ClinicReputation = () => {
    let {clinicId} = useParams()
    const [searchParams] = useSearchParams()
    const [clinic,setClinic]= useState()
    const [patientID,setPatientID] = useState(0)
    const [patientUUID,setPatientUUID] = useState("0")

    useEffect(()=>{
         setPatientID(searchParams.get("p"))
         setPatientUUID(searchParams.get("u"))
       // console.log("sending api requiest")
        clinicService.getClinicByShortCode(clinicId)
        .then(res=>{
            setClinic(res.data)
           // console.log(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    },[])
    return ( 
        <>
            <Helmet>
                <title>Eyeconx | Reputation</title>
            </Helmet>
           {clinic?<div>
            <NavTab clinic={clinic} />
            <Feedback clinic={clinic} patientID={patientID} patientUUID={patientUUID}/>
           </div>:<PageLoading/>}
                
              
        </>
     );
}
 
export default ClinicReputation;